import TabsPage from '../components/tabsPage'
import { DecodeHtml } from '../utils/decodeHtml'
import { retrunAssets } from '../utils/getAssets'
import useFetch from '../utils/useFetch'

const Convocation = () => {
  const base = 'student-hub/'
  const state1 = useFetch(base + 'convocation/')
  const state2 = useFetch(base + 'guidelines-convocation/')
  const state3 = useFetch(base + 'attire-collection-convocation/')
  const state4 = useFetch(base + 'contact-us-convocation/')

  const data1 = state1?.properties
  const data2 = state2?.properties
  const data3 = state3?.properties
  const data4 = state4?.properties

  const title = data1?.title
  const bg =
    data1?.backgroundImage != null
      ? retrunAssets(data1?.backgroundImage[0]?.url)
      : ''

  const header1 = '26TH Convocation 2024'
  const content1 = (
    <div className='flex flex-col gap-3 w-full'>
      <p className='whitespace-pre-line font-normal '>
        {DecodeHtml({ html: data1?.contents?.markup })}
      </p>

      <div className='flex flex-wrap gap-8'>
        {data1?.sessions?.items?.map((item, i) => (
          <div key={i} className='whitespace-pre-line font-normal w-fit'>
            {DecodeHtml({ html: item?.content?.properties?.table?.markup })}
          </div>
        ))}
      </div>
      <p className='whitespace-pre-line font-normal w-full '>
        {DecodeHtml({ html: data1?.invitations?.markup })}
      </p>
    </div>
  )

  const header2 = 'Guidelines'
  const content2 = (
    <div className='flex flex-col gap-3 w-full'>
      <p className='whitespace-pre-line font-normal'>
        {DecodeHtml({ html: data2?.contents?.markup })}
      </p>
      <div className='flex flex-col gap-5 border-t border-b py-4'>
        {data2?.processFlow?.items?.map((process, i) => {
          process = process?.content?.properties
          return (
            <div
              key={i}
              className='grid grid-cols-1 md:grid-cols-[20%_78%] gap-3  md:gap-10'
            >
              <h1 className='text-xl font-medium  w-full'>{process?.type}</h1>
              <p className='whitespace-pre-line font-normal'>
                {DecodeHtml({ html: process?.contents?.markup })}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )

  const header3 = 'Attire Collection'
  const content3 = (
    <div className='flex flex-col gap-3 w-full'>
      <p className='whitespace-pre-line font-normal'>
        {DecodeHtml({ html: data3?.contents?.markup })}
      </p>
    </div>
  )

  const header4 = 'Contact Us'
  const content4 = (
    <div className='flex flex-col gap-3 w-full'>
      <p className='whitespace-pre-line font-normal'>
        {DecodeHtml({ html: data4?.contents?.markup })}
      </p>
    </div>
  )

  const data = [
    {
      header: header1,
      content: content1
    },
    {
      header: header2,
      content: content2
    },
    {
      header: header3,
      content: content3
    },
    {
      header: header4,
      content: content4
    }
  ]

  return <TabsPage title={title} bg={bg} data={data} />
}

export default Convocation
